// extracted by mini-css-extract-plugin
module.exports = {"Announcement":"Announcement_Announcement__1k8tF","Wrap":"Announcement_Wrap__wJPVN"};